exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.info {\n    margin-top: 2.5em;\n}\n.info p {\n    color: #999;\n    font-size: 12px;\n}\n", ""]);

